export default {
  label: {
    filter: 'publicaciones owned y earned',
  },
};
